export default __webpack_public_path__ + "static/media/log.5ccbf3d4.png";